import type {SearchRule, SearchRules} from '../rules';

/**
 * Get a rule by index, used primarily for getting strict typing via `elementType`
 * @param rules Search rules
 * @param index Index to get rule from
 * @returns Rule at index
 */
export const getRuleAtIndex = <T extends SearchRules = SearchRules>(
	rules: T,
	index: number,
) => {
	const elementType = rules.elementTypes[index];
	const elementSubType1 = rules.elementSubType1s[index];
	const elementSubType2 = rules.elementSubType2s[index];
	const elementValue1 = rules.elementValue1s[index];
	const elementValue2 = rules.elementValue2s[index];
	const elementValue3 = rules.elementValue3s[index];

	return {
		elementType,
		elementSubType1,
		elementSubType2,
		elementValue1,
		elementValue2,
		elementValue3,
	} as SearchRule<typeof elementType>;
};

export default getRuleAtIndex;
